import dayjs from 'dayjs';

export const renderTimestamp = (ts: string) => {
  return dayjs(ts).format('MM-DD-YYYY HH:MM:ss');
}

export const abbrevAddress = (address: string) => `${address.slice(0, 5)}...${address.slice(
  address.length - 4,
  address.length
)}`